import { render, staticRenderFns } from "./promotionDynamics.vue?vue&type=template&id=34aaf54a&scoped=true"
import script from "./promotionDynamics.vue?vue&type=script&lang=js"
export * from "./promotionDynamics.vue?vue&type=script&lang=js"
import style0 from "./promotionDynamics.vue?vue&type=style&index=0&id=34aaf54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aaf54a",
  null
  
)

export default component.exports